
import dateformat from 'dateformat';
dateformat.i18n = {
    dayNames: [
        'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa',
        'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'
    ],
    monthNames: [
        'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez',
        'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ],
    timeNames: [
        'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
    ]
};

export default class Helper {
}

Helper.dateformat = function(date, format){
	return dateformat(date, format);
}

Helper.toDateString = function (date, dateOnly = false) {
	if (dateOnly) {
		return date.getFullYear() +
				'-' + Helper.pad(date.getMonth() + 1) +
				'-' + Helper.pad(date.getDate());
	}

	return date.getFullYear() +
			'-' + Helper.pad(date.getMonth() + 1) +
			'-' + Helper.pad(date.getDate()) +
			' ' + Helper.pad(date.getHours()) +
			':' + Helper.pad(date.getMinutes()) +
			':' + Helper.pad(date.getSeconds());
};

Helper.toDate = function (date, monthOnly = false) {
	if (monthOnly) {
		return Helper.pad(date.getMonth() + 1) +
				'.' + date.getFullYear();
	}
	return Helper.pad(date.getDate()) +
			'.' + Helper.pad(date.getMonth() + 1) +
			'.' + date.getFullYear();
};

Helper.dateStringToDate = function(dateString){
	let parts = dateString.split(".");
	if(parts.length === 3) {
		return new Date(parts[2] + "-" + parts[1] + "-" + parts[0]);
	}
	return false;
};

Helper.pad = function (number) {
	if (number < 10) {
		return '0' + number;
	}
	return number;
};

Helper.isWeekend = function (date) {
	if (!(date instanceof Date)) {
		throw "Please provide me with a date";
	}
	return (date.getDay() == 6 || date.getDay() == 0);
};